import { useQuery } from '@tanstack/react-query';
import { fetchTRSClusters } from 'API/TRSCluster/fetchTRSClusters';

/**
 * Simple hook for fetching TRS clusters data without table dependencies
 * Used for validation purposes in the Add page
 */
const useTRSClusters = () => {
    return useQuery({
        queryKey: ['TRSClusters-simple'],
        queryFn: fetchTRSClusters,
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000, // 10 minutes
        retry: 2,
        refetchOnWindowFocus: false,
        enabled: true,
    });
};

export default useTRSClusters;
